module.exports = __webpack_public_path__ + "img/business_d_dark.a1706def.svg";